import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/hpvHome',
    name: 'home',
    component: () => import('../views/HomeView.vue'),
    meta: {
      title: '福建省妇幼保健院'
    }
  },
  {
    path: '/hpvPatientQuery',
    name: 'hpvComponent',
    component: () => import('../views/HPVComponent.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
